
import CommentList from '~/components/Comments/CommentList.vue'
import LeaveComment from '~/components/Comments/LeaveComment.vue'
export default {
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  components: { CommentList, LeaveComment },
}
